import React from "react";
import OurProducts from "../components/OurProducts/OurProducts";
import banner1 from "../assets/images/Home/home_banner.png";
import Header from "../layout/Header";
import ProductHeroSection from "../components/OurProducts/ProductHeroSection";
import HeroSection from "../components/HeroSection";
import logo from "../assets/images/About/about-logo.png";

const OurProduct = () => {
  return (
    <>
      <HeroSection
        bannerImage={banner1}
        heading="Discover Our Products"
        description="Explore a range of innovative solutions designed to protect, assist, and empower you in every aspect of life. From travel and automotive assistance to gadget protection and cyber security, find the perfect plan to suit your needs and elevate your lifestyle."
        image={logo}
        gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
        gradientOpacity={0.9}
      />

     

      {/* next section  */}
      <OurProducts />
    </>
  );
};

export default OurProduct;
